export default function GeneralIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.05277 12.5395C1.94074 12.0968 2.27532 11.667 2.73195 11.667H10.6618C10.9832 11.667 11.2635 11.8858 11.3414 12.1977L12.7645 17.8899C12.875 18.3321 12.5406 18.7604 12.0848 18.7604H4.17259C3.85187 18.7604 3.5721 18.5427 3.49341 18.2318L2.05277 12.5395Z"
        fill="#BEE9FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09194 12.6478L4.39073 17.7796H12.2264L10.9434 12.6478H3.09194ZM2.73195 11.667C2.27532 11.667 1.94074 12.0968 2.05277 12.5395L3.49341 18.2318C3.5721 18.5427 3.85187 18.7604 4.17259 18.7604H12.5853C13.0411 18.7604 13.3755 18.3321 13.265 17.8899L11.8419 12.1977C11.7639 11.8858 11.4837 11.667 11.1622 11.667H2.73195Z"
        fill="#2B2F38"
      />
      <path
        d="M3.46024 10.6628C3.34821 10.2201 3.6828 9.79028 4.13942 9.79028H13.1575C13.4789 9.79028 13.7592 10.0091 13.8371 10.321L15.2602 16.0132C15.3708 16.4554 15.0363 16.8837 14.5805 16.8837H5.58006C5.25934 16.8837 4.97957 16.666 4.90088 16.355L3.46024 10.6628Z"
        fill="#BEE9FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49941 10.7711L5.7982 15.9029H15.5504L14.2674 10.7711H4.49941ZM4.13942 9.79028C3.6828 9.79028 3.34821 10.2201 3.46024 10.6628L4.90088 16.355C4.97957 16.666 5.25934 16.8837 5.58006 16.8837H15.9093C16.3651 16.8837 16.6995 16.4554 16.589 16.0132L15.1659 10.321C15.0879 10.0091 14.8077 9.79028 14.4862 9.79028H4.13942Z"
        fill="#2B2F38"
      />
      <path
        d="M4.71146 8.51701C4.59943 8.07434 4.93402 7.64453 5.39064 7.64453H14.4087C14.7302 7.64453 15.0104 7.86332 15.0884 8.1752L16.5114 13.8675C16.622 14.3097 16.2875 14.738 15.8318 14.738H6.83128C6.51056 14.738 6.23079 14.5202 6.1521 14.2093L4.71146 8.51701Z"
        fill="#BEE9FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75063 8.62536L7.04942 13.7572H15.4728L14.1899 8.62536H5.75063ZM5.39064 7.64453C4.93402 7.64453 4.59943 8.07434 4.71146 8.51701L6.1521 14.2093C6.23079 14.5202 6.51056 14.738 6.83128 14.738H15.8318C16.2875 14.738 16.622 14.3097 16.5114 13.8675L15.0884 8.1752C15.0104 7.86332 14.7302 7.64453 14.4087 7.64453H5.39064Z"
        fill="#2B2F38"
      />
      <path
        d="M6.04789 6.37126C5.93586 5.92859 6.27044 5.49878 6.72706 5.49878H15.6888C16.0356 5.49878 16.3302 5.7525 16.3816 6.09546L17.2353 11.7877C17.2989 12.2113 16.9708 12.5922 16.5425 12.5922H8.1677C7.84698 12.5922 7.56722 12.3745 7.48853 12.0635L6.04789 6.37126Z"
        fill="#BEE9FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.08706 6.4796L8.38585 11.6114H16.2171L15.4474 6.4796H7.08706ZM6.72706 5.49878C6.27044 5.49878 5.93586 5.92859 6.04789 6.37126L7.48853 12.0635C7.56722 12.3745 7.84698 12.5922 8.1677 12.5922H16.5425C16.9708 12.5922 17.2989 12.2113 17.2353 11.7877L16.3816 6.09546C16.3302 5.7525 16.0356 5.49878 15.6888 5.49878H6.72706Z"
        fill="#2B2F38"
      />
      <path
        d="M7.44144 4.46672C7.32941 4.02405 7.664 3.59424 8.12062 3.59424H17.1387C17.4601 3.59424 17.7404 3.81303 17.8183 4.12491L18.5299 6.97105L17.5815 9.81719C17.6921 10.2594 17.3577 10.6877 16.9019 10.6877H9.56126C9.24054 10.6877 8.96077 10.4699 8.88208 10.159L7.44144 4.46672Z"
        fill="#BEE9FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.48061 4.57506L9.7794 9.70687H16.5609L17.5613 7.14097L16.9199 4.57506H8.48061ZM8.12062 3.59424C7.664 3.59424 7.32941 4.02405 7.44144 4.46672L8.88208 10.159C8.96077 10.4699 9.24054 10.6877 9.56126 10.6877H16.9199C17.3756 10.6877 17.7101 10.2594 17.5995 9.81719L18.5299 6.97105L17.8183 4.12491C17.7404 3.81303 17.4601 3.59424 17.1387 3.59424H8.12062Z"
        fill="#2B2F38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7131 5.98919C15.7131 6.26004 15.515 6.4796 15.2706 6.4796H10.369C10.1246 6.4796 9.9265 6.26004 9.9265 5.98919C9.9265 5.71834 10.1246 5.49878 10.369 5.49878H15.2706C15.515 5.49878 15.7131 5.71834 15.7131 5.98919Z"
        fill="#2B2F38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1804 8.13494C14.1804 8.40579 13.9843 8.62536 13.7425 8.62536H11.0492C10.8073 8.62536 10.6112 8.40579 10.6112 8.13494C10.6112 7.8641 10.8073 7.64453 11.0492 7.64453H13.7425C13.9843 7.64453 14.1804 7.8641 14.1804 8.13494Z"
        fill="#2B2F38"
      />
      <path
        d="M17.2459 11.5016L19.2166 3.49414L10.6147 14.2542H15.6507L12.8981 22.6058L21.9691 11.5016H17.2459Z"
        fill="#FFDB59"
        stroke="#2B2F38"
        strokeLinejoin="round"
      />
    </svg>
  )
}
